import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

const ChartLoading = () => {
  return (
    <Stack>
      <Skeleton
        variant="rounded"
        width={"100%"}
        height={450}
        sx={{ borderRadius: 5 }}
      />
      <Skeleton
        variant="rounded"
        width={"100%"}
        height={450}
        sx={{ marginTop: 10, borderRadius: 5 }}
      />
    </Stack>
  );
};

export default ChartLoading;
